import React from 'react';
import { clsx } from 'clsx';

type Align = 'left' | 'center' | 'right';
type Props = {
  disabled?: boolean;
  placeholder: string;
  align?: Align;
};

export function PlaceholderTextField({ disabled, placeholder, align = 'left' }: Props) {
  return (
    <div className="h-full w-full p-1">
      <div
        className={clsx(
          'flex h-full w-full items-center rounded-sm border border-gray-300 px-2',
          calcAlign(align),
          disabled ? 'text-gray-400' : 'text-blue-600'
        )}>
        {placeholder}
      </div>
    </div>
  );
}

function calcAlign(align: Align): string {
  switch (align) {
    case 'left':
      return 'text-left';
    case 'center':
      return 'text-center';
    case 'right':
      return 'text-right';
  }
}
